module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('Navbar'), _vm._v(" "), (_vm.home) ? _c('div', {
    staticClass: "parallax-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "parallax"
  }, [_c('img', {
    attrs: {
      "src": _vm.src
    }
  })])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "cover-title"
    }
  }, [_c('h1', [_vm._v("SPYC Library")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4deaff94!./~/vue-loader/lib/selector.js?type=template&index=0!./assets/js/component/Header.vue
// module id = 76
// module chunks = 0